import { render, staticRenderFns } from "./ProductPaymentsModal.vue?vue&type=template&id=2ecdd8f1&"
import script from "./ProductPaymentsModal.vue?vue&type=script&lang=js&"
export * from "./ProductPaymentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports